import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IImportCost } from "src/models/Products/ImportCost.models";

interface ImportCostState {
    importCosts: IImportCost[];
    importCostToEdit: IImportCost | null;
}

const initialState: ImportCostState = {
    importCosts: [],
    importCostToEdit: null,
};

const ImportCostSlice = createSlice({
    name: "ImportCost",
    initialState,
    reducers: {
    setImportCostList: (
        state,
        action: PayloadAction<IImportCost[]>
    ) => {
        state.importCosts = action.payload;
    },
    concatListImportCost: (
        state: ImportCostState,
        action: PayloadAction<IImportCost[]>
    ) => {
        state.importCosts = [
            ...state.importCosts.concat(action.payload),
        ];
    },
    setImportCostToEdit: (
        state,
        action: PayloadAction<IImportCost | null>
    ) => {
        state.importCostToEdit = action.payload;
    },
    addImportCost: (state, action: PayloadAction<IImportCost>) => {
        state.importCosts.push(action.payload);
    },
    updateImportCost: (state, action: PayloadAction<IImportCost>) => {
        let itemIndex = state.importCosts.findIndex(
            item => item.importCostId === action.payload.importCostId
        );
        if (itemIndex !== -1) state.importCosts[itemIndex] = action.payload;
    },
    deleteImportCost: (state, action: PayloadAction<number>) => {
        const newArray = state.importCosts.filter(
            item => item.importCostId !== action.payload
        );
        state.importCosts = newArray;
    },
    },
});

export const {
    setImportCostList,
    concatListImportCost,
    setImportCostToEdit,
    addImportCost,
    updateImportCost,
    deleteImportCost,
} = ImportCostSlice.actions;

export default ImportCostSlice.reducer;